export default __webpack_public_path__ + "static/aboutus6-480-e78e563c848d8d97d8339f26d5488204.png";